import * as CubeTree from '../../../cubeTree/index';
import * as UIToolkit from '../../../UIToolkit/index';
import Config from '../../../config/index';
import Utils from '../../../utils/util';
import Service from '../../../service/index';
import Visit from '../../visit';

interface MoveSubOutParams {
    moveTaskQueue: MoveTask,
    subSku: SkuData,
    mainCube: CubeNode,
    copySubList: SkuData[],
    currentRenderData: FreeObjMap
}

async function performRemoveSubTask(moveTaskQueue: MoveTask, dragSubGoodsInfo: FreeObjMap|null, dragSubGoodsIndex: number): Promise<any> {
    let mainGoodsCubeId: CubeId = moveTaskQueue.logic[0].from.moveTarget;
    let mainGoodsCubeNode: CubeNode = CubeTree.findByCubeId(mainGoodsCubeId);
    let subList: SkuData[] = CubeTree.getCubeValueById(mainGoodsCubeId, 'subSkuList');
    let copySubList: SkuData[] = Utils.deepCopy(subList);
    let dragIndex: number = dragSubGoodsIndex + 1;
    let subSku: SkuData = subList.splice(dragIndex, 1)[0];
    let stageWindow: StageWindow = window;
    let currentRenderData: FreeObjMap = stageWindow.R_WIN_ATTR.getRenderData(1);
    let checkResult: FreeObjMap = moveCheck(mainGoodsCubeNode, subList, currentRenderData);

    if (checkResult.code !== '0000') {
        // 放弃移动
        removeGiveUp(mainGoodsCubeNode, copySubList, currentRenderData);
        return 'fail';
    }

    UIToolkit.showLoading();

    try {
        await moveSubOut({
            moveTaskQueue,
            subSku,
            copySubList,
            currentRenderData,
            mainCube: mainGoodsCubeNode
        });
        UIToolkit.hideLoading();
        return 'success';
    }
    catch(err) {
        // 放弃移动
        removeGiveUp(mainGoodsCubeNode, copySubList, currentRenderData);
        UIToolkit.tips('移动失败');
        UIToolkit.hideLoading();
        return 'fail';
    }
}

async function moveSubOut(params: MoveSubOutParams): Promise<void> {
    let stageWindow: StageWindow = window;
    let paperId: number = Config.get({
        moduleName: 'base',
        key: 'paperId'
    });
    let subSkuInfo: FreeObjMap = await Service.getSubSkuCubeInfo({
        displayId: paperId,
        removeCube: JSON.stringify(params.subSku),
        parentCube: JSON.stringify(params.mainCube)
    });
    let hasSizeError: boolean = CubeTree.goodsInfoHasSizeError(subSkuInfo);

    if (hasSizeError) {
        UIToolkit.tips('子码商品没有尺寸信息不能添加到图纸上');
        removeGiveUp(params.mainCube, params.copySubList, params.currentRenderData);
        return;
    }

    let addTaskList: Array<AddTask> = makeAddTask(subSkuInfo);
    let addCube: CubeId[] = await Visit.Add.runAddTaskQueue(addTaskList);

    modifyMoveTaskQueue(addCube[0], params.moveTaskQueue);
}

function moveCheck(mainGoodsCubeNode: CubeNode, subList: SkuData[], currentRenderData: FreeObjMap): FreeObjMap {
    let stageWindow: StageWindow = window;
    let checkResult: FreeObjMap = stageWindow.FILTER_OF_STAGECORE.panelPreCheck([mainGoodsCubeNode], 1, {
        key: 'subSkuList',
        value: subList,
        flag: subList.length == 1 ? true : false
    }, currentRenderData);

    return checkResult;
}

function modifyMoveTaskQueue(addCube: CubeId, moveTaskQueue: MoveTask) {
    moveTaskQueue.logic.forEach((task: LogicMoveTask): void => {
        task.from.moveTarget = addCube;
    });
    moveTaskQueue.physics.forEach((task: PhysicsMoveTask): void => {
        task.from.moveTarget = addCube;
        task.to.moveTarget = addCube;
    });
}

function removeGiveUp(cube: CubeNode, subList: SkuData[], currentRenderData: FreeObjMap): void {
    let stageWindow: StageWindow = window;

    stageWindow.FILTER_OF_STAGECORE.panelPreCheck([cube], 1, {
        key: 'subSkuList',
        value: subList
    }, currentRenderData);
}

function makeAddTask(cubeData: FreeObjMap): Array<AddTask> {
    let result: Array<AddTask> = [];

    result.push({
        type: 'goods',
        cubeData: cubeData,
        extendParams: {
            addType: 'normal'
        }
    });

    return result;
}

export {
    performRemoveSubTask
};
